import "swiper/css"
import "swiper/css/effect-fade"

import Swiper from "swiper"
import { EffectFade, Navigation, Pagination, Thumbs } from "swiper/modules"
import { SwiperOptions } from "swiper/types"

type CarouselProps = {
  mode: "card" | "fade" | "news" | ""
  cardsize: "small" | "large"
}

const defaultConfig: SwiperOptions = {
  autoHeight: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 132,
}

const smallCards = {
  572: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 3,
  },
  984: {
    slidesPerView: 3.5,
  },
  1200: {
    slidesPerView: 4,
  },
}

const largeCards = {
  572: {
    slidesPerView: 1.5,
  },
  768: {
    slidesPerView: 2,
  },
  984: {
    slidesPerView: 2.5,
  },
  1200: {
    slidesPerView: 3,
  },
}

const cardConfig: SwiperOptions = {
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 24,
}

function carousel(el: HTMLElement, props: CarouselProps) {
  const carouselMain = el.querySelector<HTMLDivElement>(".carousel-main.swiper")
  const carouselTabs = el.querySelector<HTMLDivElement>(
    ".carousel-tabs>.swiper"
  )
  const carouselNav = el.querySelector<HTMLDivElement>(".carousel-navigation")
  const carouselPagination = el.querySelector<HTMLDivElement>(
    ".carousel-pagination"
  )

  if (!carouselMain) {
    return
  }

  const carouselSlides =
    carouselMain.querySelectorAll<HTMLDivElement>(".swiper-slide")

  let tabs

  if (carouselTabs) {
    tabs = new Swiper(carouselTabs, {
      slidesPerView: "auto",
      spaceBetween: 24,
      watchSlidesProgress: true,
      breakpoints: {
        1199: {
          spaceBetween: 36,
        },
      },
    })
  }

  const mode = props.mode

  const baseConfig =
    mode === "card"
      ? {
          ...cardConfig,
          breakpoints: props.cardsize === "small" ? smallCards : largeCards,
        }
      : mode === "news"
        ? { ...defaultConfig, spaceBetween: 0 }
        : defaultConfig

  const carouselSwiper = new Swiper(carouselMain, {
    ...baseConfig,
    setWrapperSize: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: carouselNav
      ? {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          addIcons: false,
        }
      : undefined,
    thumbs: tabs ? { swiper: tabs } : undefined,
    effect: mode === "fade" ? "fade" : undefined,
    fadeEffect: {
      crossFade: true,
    },
    on: {
      init: function () {
        el.classList.add("opacity-100")
      },
    },
    modules: carouselNav
      ? [Pagination, Thumbs, EffectFade, Navigation]
      : [Pagination, Thumbs, EffectFade],
  })

  if (carouselSwiper.isLocked) {
    carouselNav?.classList.add("hidden")
    carouselPagination?.classList.add("hidden")
  }

  carouselSwiper.on("lock", () => {
    carouselNav?.classList.add("hidden")
    carouselPagination?.classList.add("hidden")
  })

  carouselSwiper.on("unlock", () => {
    carouselNav?.classList.remove("hidden")
    carouselPagination?.classList.remove("hidden")
  })

  if (carouselSlides.length > 0) {
    const firstSlide = carouselSlides[0]
    const wistiaContainer = firstSlide?.querySelector<HTMLDivElement>(
      "[data-ca-wistia-player]"
    )
    if (wistiaContainer) {
      const observer = new MutationObserver((mutations, observer) => {
        mutations.forEach(mutation => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "data-media-loaded"
          ) {
            carouselSwiper.update()
            observer.disconnect()
          }
        })
      })
      observer.observe(wistiaContainer, {
        attributes: true,
      })
    }
  }
}
export default carousel
